// Estas importaciones son en realidad un antipatrón, ya que se está accediendo a
// componentes privados dentro de los componentes. El único consuelo que nos queda
// es que en realidad solo se está accediendo a los tipos (interfaces) y no a los
// componentes en sí... No sé si es un gran consuelo.
// TODO: Quizás se pueda extraer la interfaz fuera del componente, para ser usada.
import { Datos as MatriculaDatos } from '../componentes/S3Alumnos/componentes/Alumno/componentes/DatosMatricula';
import { Datos as PreuniversitarioDatos } from '../componentes/S3Alumnos/componentes/Alumno/componentes/DatosMatricula/componentes/DatosMatriculaPreu';

export function calcularArancelAsignaturas(matricula: MatriculaDatos): number {
    if (matricula.area === 'preu') {
        return calcularValorPreu(matricula.detallePreu, matricula.plan);
    } else {
        return calcularValorIngles(matricula.plan);
    }
}

function calcularValorIngles(plan: string): number {
    return 0;
}

function calcularValorPreu(datos: PreuniversitarioDatos, plan: string): number {
    return 0;
}



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/servicios/calculoDeValoresPorArea.ts